import { ProductosApiService } from '../../../../../service/api/productos-api';
import { TareasApiService } from '../../../../../service/api/tareas-api.service';
import { FormCommonApiService } from '../../../../../service/api/formcommon-api.service';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DashboardService } from '../../../../../service/events/dashboard.service';
import { BaseForm } from '../../../../base-form';
import { FincasApiService } from '../../../../../service/api/fincas-api.service';
import { TrabajadoresApiService } from '../../../../../service/api/trabajadores-api.service';
import { TratamientosApiService } from '../../../../../service/api/tratamientos-api.service';
import { FitosanitariosFormDefinition } from './form-control/form-definition';
import {
  FitosanitariosSupportDataSourcesFactory,
  type FitosanitariosSupportDataEndpoints,
} from './fitosanitarios-support-data-sources.factory';
import {
  FITOSANITARIOS_FORM_SUPPORT_DATA_KEYS,
  type FitosanitariosFormSupportDataKey,
} from './form-control/fitosanitarios-form-load-plan';
import { EventPhase, FormPhase, ReactiveFormRequestCoordinator } from '@fitogest/reactive-form-builder/form-request';
import {
  ReactiveCascadeController,
  ReactiveFormSupportDataExecutor,
  type ReactiveCascadeResetTarget,
  ReactiveDropdownSyncController,
  ReactiveSelectionResolver,
  type ReactiveDropdownFieldRefreshMode,
  type ReactiveFormLoadPlan,
  type ReactiveFormLoadReadinessSnapshot,
} from '@fitogest/reactive-form-builder/utils';
import { ClientesApiService } from '../../../../../service/api/clientes-api.service';
import { StorageManager } from '../../../../../common/storage-manager.class';
import { WeatherService } from '../../../../../service/api/weather/weather';
import { RecuperarReferenciaRecetaService } from '../../../../../service/recuperar.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { SiexApiService } from '../../../../../service/api/siex-api.service';
import { UsuariosApiService } from '../../../../../service/api/usuarios-api.service';
import { firstValueFrom } from 'rxjs';
import { TareaFitoModel } from '../../../../../models/tareas/tarea-fito.model';
import { TratamientosControlModel } from '../../../../../models/tratamientos/tratamientos-control.model';
import {
  DropdownData,
  FilteredValue,
  FormType,
  ReactiveFormChangedField,
  ReactiveFormLifecycleEvent,
  ReactiveFormStableValueChange,
  ReactiveFormSupportDataMetricsEvent,
  ReactiveFormValue,
  type ReactiveLazyDropdownFilterRequest,
} from '@fitogest/reactive-form-builder/interfaces';
import type {
  ReactiveFormSupportDataReadinessItem,
  ReactiveFormSupportDataReadinessPhase,
  ReactiveFormSupportDataReadinessSeverity,
  ReactiveFormSupportDataReadinessStatus,
} from '@fitogest/reactive-form-builder/components';
import { FitosanitariosEnvironmentDefinition } from '../environment-variables';
import { environment } from '../../../../../../environments/environment';
import moment from 'moment';
import { MessageService } from 'primeng/api';
import { Utils } from '../../../../../common/utils';
import { ClienteModel } from '../../../../../models/cliente.model';
import { ParcelasModel } from '../../../../../models/form-common/parcelas.model';
import { SectorModel } from 'src/app/models/form-common/sector.model';
import { Validators } from '@angular/forms';
import { TratamientosModel } from 'src/app/models/tratamientos/tratamientos.model';
import { BrowserDiagnosticsService } from 'src/app/common/diagnostics/browser-diagnostics.service';
import type { DiagnosticMetric, DiagnosticSupportDataThresholdInput } from 'src/app/common/diagnostics/diagnostic-types';

const _createdAgroForFitoIds = new Set<string>();

const PREVIOUS_DATA_PATCH_FIELD = '__previous_data_patch';
const DROPDOWN_REFRESH_FIELD = '__dropdown_refresh';
const FITOSANITARIOS_SUPPORT_DATA_DIAGNOSTIC_GROUP = 'support-data';

type FitosanitariosLocationRefreshScope = {
  readonly clientId: string;
  readonly fincaId: string;
  readonly sectorIds: readonly string[];
};

type FitosanitariosCascadeField =
  'id_sector' |
  'ids_parcelas' |
  'id_tratamiento' |
  'ids_productos';


type FitosanitariosSupportDataPhase = ReactiveFormSupportDataReadinessPhase;

type FitosanitariosSupportDataReadinessItem = ReactiveFormSupportDataReadinessItem;

type FitosanitariosSupportDataVisualStatus = ReactiveFormSupportDataReadinessStatus;

const FITOSANITARIOS_SUPPORT_DATA_LABELS: Record<FitosanitariosFormSupportDataKey, string> = {
  [FITOSANITARIOS_FORM_SUPPORT_DATA_KEYS.clientes]: 'Clientes',
  [FITOSANITARIOS_FORM_SUPPORT_DATA_KEYS.tratamientos]: 'Tratamientos',
  [FITOSANITARIOS_FORM_SUPPORT_DATA_KEYS.justificaciones]: 'Justificación de la actuación',
  [FITOSANITARIOS_FORM_SUPPORT_DATA_KEYS.maquinarias]: 'Maquinaria',
  [FITOSANITARIOS_FORM_SUPPORT_DATA_KEYS.trabajadores]: 'Trabajadores',
  [FITOSANITARIOS_FORM_SUPPORT_DATA_KEYS.usuarios]: 'Asignados',
  [FITOSANITARIOS_FORM_SUPPORT_DATA_KEYS.productos]: 'Productos',
};


@Component({
  selector: 'app-formulario-pulverizacion',
  standalone: false,
  templateUrl: './fitosanitarios-form.component.html',
  styleUrls: ['./fitosanitarios-form.component.scss'],
})
export class FitosanitariosFormComponent extends BaseForm<TareaFitoModel> implements OnInit, OnDestroy {
  private static readonly DEBUG_REPEATED_CHANGE_THRESHOLD = 20;

  private static readonly DEBUG_LOG_INTERVAL = 10;

  private static readonly MINUTES_PER_HOUR = 60;

  private static readonly HOURS_PER_DAY = 24;

  private static readonly MAX_TIME_MINUTE = 59;

  private static readonly TIME_PART_PAD_LENGTH = 2;

  private static readonly TRATAMIENTO_FIELD_NAMES = ['id_tratamiento', 'tratamiento_nombre'] as const;

  private static readonly TRATAMIENTOS_REMOTE_RESULT_LIMIT = 50;

  disabledDates: Date[] = [];

  form!: FitosanitariosFormDefinition;

  formRequest: ReactiveFormRequestCoordinator<TareaFitoModel>;

  env: FitosanitariosEnvironmentDefinition = new FitosanitariosEnvironmentDefinition();

  rol = StorageManager.getUser().rol;

  public loadingData = true;

  public readonly debugFitosanitariosForm = localStorage.getItem('debugFitosanitariosForm') === '1';


  public isReactiveFormReady = false;

  public reactiveFormLoadingError = '';

  public readonly reactiveFormLoadingLabel = 'Preparando formulario fitosanitario...';

  public reactiveFormRecordId = '';

  public reactiveFormLoadPlan: ReactiveFormLoadPlan | null = null;

  public reactiveFormLoadReadiness: ReactiveFormLoadReadinessSnapshot | null = null;

  public readonly fitosanitariosSupportDataReadinessTitle = 'Datos complementarios del formulario';

  public fitosanitariosSupportDataReadinessSummary = '';

  public fitosanitariosSupportDataReadinessSeverity: ReactiveFormSupportDataReadinessSeverity = 'info';

  public fitosanitariosSupportDataReadinessItems: FitosanitariosSupportDataReadinessItem[] = [];

  public previousDataLoaded: TareaFitoModel | null = null;

  public initialPreviousData: TareaFitoModel | null = null;

  public getRequest = this.tareasApi.fitosanitariosGET;

  private formChangesDebugCount = 0;

  private repeatedChangeDebugCount = 0;

  private lastDebugChangedFieldName = '';

  private lastReloadedClientDropdownId = '';

  private lastLoadedTratamientosClientId = '';

  private lastTratamientosRemoteFilterKey = '';

  private isLoadingTratamientosOnDemand = false;

  private lastDeclarativeLocationRefreshScope: FitosanitariosLocationRefreshScope | null = null;

  private pendingDeclarativeLocationRefreshFields: readonly string[] = [];

  private hasPendingDeclarativeLocationRefresh = false;

  private hasPendingReactiveDropdownMappingsRefresh = false;

  private isLoadingInitialDropdowns = false;

  private isReloadingClientDropdowns = false;

  private criticalSupportDataReady = false;

  private deferredSupportDataReady = false;

  private readonly loadingSupportDataPhases = new Set<FitosanitariosSupportDataPhase>();

  private readonly failedSupportDataPhases = new Set<FitosanitariosSupportDataPhase>();

  productsTratamientos: any[] = [];

  private readonly diagnostics = inject(BrowserDiagnosticsService);

  private _multiselectMergeOverride: Record<string, any[]> = {};


  constructor(
    public override route: ActivatedRoute,
    public override dashboard: DashboardService,
    public formApi: FormCommonApiService,
    public usuariosApi: UsuariosApiService,
    public tareasApi: TareasApiService,
    public fincasApi: FincasApiService,
    public trabajadoresApi: TrabajadoresApiService,
    public tratamientosApi: TratamientosApiService,
    public clientesApi: ClientesApiService,
    public productosApi: ProductosApiService,
    public siexApi: SiexApiService,
    public override router: Router,
    public dashboardEvent: DashboardService,
    private weatherService: WeatherService,
    private recuperarService: RecuperarReferenciaRecetaService,
    private http: HttpClient,
    private messageService: MessageService,
  ) {
    super(
      route,
      router,
      dashboard,
      tareasApi.fitosanitariosPUT,
      tareasApi.fitosanitariosPOST,
      'fitosanitarios',
      'Actualizar Tarea Fitosanitaria',
      'Realizar Tarea Fitosanitaria',
      'Duplicar Tarea Fitosanitaria',
    );
    this.formRequest = new ReactiveFormRequestCoordinator<TareaFitoModel>();
  }

  public async ngOnInit(): Promise<void> {
    this.dashboard.clientChanges$.subscribe(() => {
      this.fincasApi.fincasGET.unsuscribe();
      this.fincasApi.sectoresGET.unsuscribe();
      this.fincasApi.parcelasGET.unsuscribe();
      this.tratamientosApi.tratamientosList.unsuscribe();
      if (this.env.filterAplicadoresByClient) {
        this.trabajadoresApi.trabajadoresGET.unsuscribe();
        this.trabajadoresApi.maquinariaGET.unsuscribe();
      }
    });

    this.expandFormRequest();
    this.softInit(this.getType());
    this.resetExternalDropdowns();

    try {
      await this.setupFormConFechas();
      this.markReactiveFormReady();
      this.initDeferredFormData().catch((error: unknown) => {
        this.debugFito('Deferred fitosanitarios data load failed.', error);
        console.error('Error loading deferred fitosanitarios form data.', error);
      });
    } catch (error: unknown) {
      this.loadingData = false;
      this.isLoadingInitialDropdowns = false;
      this.finalizeExternalDropdowns();
      this.hostController.setLoadBlockingErrors(true);
      this.updateReactiveFormLoadReadiness();
      this.reactiveFormLoadingError = this.getReadableInitialisationError(error);
      console.error('No se ha podido preparar el formulario fitosanitario.', error);
    }
  }

  override ngOnDestroy(): void {
    this.messageService.clear();

    if (this._checkAppsTimer) {
      clearTimeout(this._checkAppsTimer);
      this._checkAppsTimer = null;
    }
  }

  onAfterSend(serverResponse?: any): void {
    if (this.getType() === FormType.CREATION || this.getType() === FormType.DUPLICATION) {
      const idTareaFito = Array.isArray(serverResponse)
        ? serverResponse[0]?.id ?? null
        : serverResponse?.data?.id ?? serverResponse?.id ?? null;

      if (!idTareaFito) return;

      const cultivoRaw: string = Array.isArray(serverResponse)
        ? serverResponse[0]?.cultivo ?? ''
        : serverResponse?.cultivo ?? '';

      const isArroz = cultivoRaw
        .split(';')
        .some(c => c.trim().toLowerCase() === 'arroz');

      if (!isArroz) return;

      // Evitar doble creación para el mismo id de tarea fito
      if (_createdAgroForFitoIds.has(String(idTareaFito))) return;
      _createdAgroForFitoIds.add(String(idTareaFito));

      this.createTaskAgro(String(idTareaFito));

    } else if (this.getType() === FormType.EDITION) {
      this.updateTaskAgro();
    }
  }

  async createTaskAgro(idTareaFito?: string | null) {
    if (environment.appName !== 'avafitogest') return;
    if (!idTareaFito) return;

    const parcelas = this.form.model.ids_parcelas as ParcelasModel[];
    const idsParcelas = parcelas.map(p => p.id).join(';');
    const idsSectores = (this.form.model.id_sector as SectorModel[])
      .map(s => s.id).join(';');

    const anio = this.getYearFromDDMMYYYY(this.form.model.fecha_fin as string)
      ?? this.getYearFromDDMMYYYY(this.form.model.fecha_inicio as string)
      ?? new Date().getFullYear();

    const fechaFinStr = this.form.model.fecha_fin as string;
    const fechaSecaInicio = moment(Utils.toDate(fechaFinStr)).add(-1, 'days').format('DD/MM/YYYY');
    const fechaSecaFin    = moment(Utils.toDate(fechaFinStr)).add(+1, 'days').format('DD/MM/YYYY');

    const tieneZonaBaja = parcelas.some(p =>
      (p.zona_riego ?? '').toString().toLowerCase().includes('baja')
    );

    let fechaInicioCultivo: string;
    let fechaFinCultivo: string;
    let diaInicioStr = '';
    let diaFinStr    = '';
    let fechaInicioInvernal: string | null = null;
    let fechaFinInvernal: string | null = null;
    let fechasReutilizadas = false;

    try {
      const paramsGetAgro = new HttpParams()
        .append('p1', 'generic')
        .append('p2', 'tareas_agroambientales')
        .append('id_cliente', String(this.form.model.id_cliente ?? ''));

      const agroResp: any = await firstValueFrom(
        this.http.get<any>(`${environment.serverUrl}ws/index.php`, { params: paramsGetAgro })
      );

      const agroLista: any[] = Array.isArray(agroResp)
        ? agroResp
        : (agroResp?.data ?? []);

      const parcelaIdsSet = new Set(idsParcelas.split(';').filter(Boolean));

      const tareaRef = agroLista.find(t => {
        if (!t?.fecha_inicio_inundacion_cultivo || !t?.fecha_fin_inundacion_cultivo) return false;
        const tParcelas = (t.id_parcelas ?? '').toString().split(';').filter(Boolean);
        return tParcelas.some((id: string) => parcelaIdsSet.has(id));
      }) ?? null;

      if (tareaRef) {
        fechaInicioCultivo = tareaRef.fecha_inicio_inundacion_cultivo;
        fechaFinCultivo    = tareaRef.fecha_fin_inundacion_cultivo;
        if (tareaRef.fecha_inicio_inundacion_invernal && tareaRef.fecha_fin_inundacion_invernal) {
          fechaInicioInvernal = tareaRef.fecha_inicio_inundacion_invernal;
          fechaFinInvernal    = tareaRef.fecha_fin_inundacion_invernal;
        }
        fechasReutilizadas = true;
      }
    } catch (e) {
      console.error('Error buscando tareas_agroambientales previas:', e);
    }

    if (fechasReutilizadas) {
      const mInicio = fechaInicioCultivo!.match(/^(\d{2})\//);
      const mFin    = fechaFinCultivo!.match(/^(\d{2})\//);
      const diaInicioExtraido = mInicio ? parseInt(mInicio[1] ?? '0', 10) : 0;
      const diaFinExtraido    = mFin    ? parseInt(mFin[1]    ?? '0', 10) : 0;

      const diaInicio = (diaInicioExtraido >= 11 && diaInicioExtraido <= 14)
        ? diaInicioExtraido
        : this.randomIntBetween(11, 14);
      const diaFin = (diaFinExtraido >= 15 && diaFinExtraido <= 18)
        ? diaFinExtraido
        : this.randomIntBetween(15, 18);

      diaInicioStr = String(diaInicio).padStart(2, '0');
      diaFinStr    = String(diaFin).padStart(2, '0');

      fechaInicioCultivo = `${diaInicioStr}/05/${anio}`;
      fechaFinCultivo    = `${diaFinStr}/08/${anio}`;
    } else {
      const diaInicio = this.randomIntBetween(11, 14);
      const diaFin    = this.randomIntBetween(15, 18);
      diaInicioStr = String(diaInicio).padStart(2, '0');
      diaFinStr    = String(diaFin).padStart(2, '0');
      fechaInicioCultivo = `${diaInicioStr}/05/${anio}`;
      fechaFinCultivo    = `${diaFinStr}/08/${anio}`;
    }

    let fecha_siembra: string | null = null;
    let dosis_siembra: string | null = null;
    let fecha_arroz: string | null = null;
    let fecha_nivelacion: string | null = null;

    try {
      const paramsGet = new HttpParams()
        .append('p1', 'generic')
        .append('p2', 'tareas_ecorregimenes')
        .append('id_cliente', String(this.form.model.id_cliente ?? ''));

      const ecoResp: any = await firstValueFrom(
        this.http.get<any>(`${environment.serverUrl}ws/index.php`, { params: paramsGet })
      );

      const ecoLista: any[] = (Array.isArray(ecoResp)
        ? ecoResp
        : (ecoResp?.data ?? [])
      ).filter((t: any) => String(t?.id_cliente ?? '') === String(this.form.model.id_cliente ?? ''));

      const normalize = (s: any) =>
        (s ?? '').toString()
          .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
          .toLowerCase();

      const ecoNivelacion = ecoLista.find(t =>
        t?.fecha_siembra &&
        t?.dosis_siembra &&
        t?.fecha_recoleccion_arroz &&
        t?.fecha_malashierbas &&
        normalize(t?.tareas_malashierbas).includes('nivelacion')
      ) ?? null;

      const ecoFallback = ecoLista.find(t =>
        t?.fecha_siembra &&
        t?.dosis_siembra &&
        t?.fecha_recoleccion_arroz &&
        t?.fecha_malashierbas
      ) ?? null;

      const ecoRef = ecoNivelacion ?? ecoFallback;

      if (ecoRef) {
        fecha_siembra    = ecoRef.fecha_siembra;
        dosis_siembra    = ecoRef.dosis_siembra;
        fecha_arroz      = ecoRef.fecha_recoleccion_arroz;
        fecha_nivelacion = ecoRef.fecha_malashierbas;
      }
    } catch (e) {
      console.error('Error obteniendo tareas_ecorregimenes:', e);
    }

    const taskAgro: Record<string, any> = {
      id_cliente:                      this.form.model.id_cliente,
      id_usuario:                      StorageManager.getUser().id,
      id_finca:                        (this.form.model.id_finca as any).id,
      id_sector:                       idsSectores,
      id_parcelas:                     idsParcelas,
      fecha_seca_inicio_intermitente:  fechaSecaInicio,
      fecha_seca_fin_intermitente:     fechaSecaFin,
      fecha_inicio_inundacion_cultivo: fechaInicioCultivo!,
      fecha_fin_inundacion_cultivo:    fechaFinCultivo!,
      tipo_ecorregimen:                'Arroz',
      id_tarea_fito:                   idTareaFito,
      fecha_siembra:                   fecha_siembra,
      dosis_siembra:                   dosis_siembra,
      fecha_arroz:                     fecha_arroz,
      fecha_nivelacion:                fecha_nivelacion,
    };

    if (tieneZonaBaja) {
      taskAgro['fecha_inicio_inundacion_invernal'] = fechaInicioInvernal ?? `${diaInicioStr}/11/${anio}`;
      taskAgro['fecha_fin_inundacion_invernal']    = fechaFinInvernal    ?? `${diaFinStr}/01/${anio + 1}`;
    }

    const paramsPost = new HttpParams()
      .append('p1', 'generic')
      .append('p2', 'tareas_agroambientales');

    firstValueFrom(
      this.http.post<any>(`${environment.serverUrl}ws/index.php`, taskAgro, { params: paramsPost })
    ).catch(e => {
      console.error('Error en createTaskAgro:', e);
      _createdAgroForFitoIds.delete(String(idTareaFito));
    });
  }

  public stableValueChanges(event: ReactiveFormStableValueChange<TareaFitoModel>): void {
    const changedFieldName = String(event.changedField ?? '');
    const modelChanges = this.captureStableValueChange(event.value as TareaFitoModel);

    this.form.model = {
      ...this.form.model,
      ...modelChanges,
    } as TareaFitoModel;
    this.syncModelFromForm();

    if (changedFieldName === PREVIOUS_DATA_PATCH_FIELD) {
      this.applyLoadedReactiveState();
      return;
    }

    if (changedFieldName === DROPDOWN_REFRESH_FIELD) {
      this.syncModelFromForm();
      return;
    }

    if (event.origin !== 'user') {
      return;
    }

    this.handleFormValueChange(event.value, event.changedField);
  }

  public reactiveFormChanges(
    formModel: ReactiveFormValue<TareaFitoModel>,
    lastChangedFieldName: ReactiveFormChangedField<TareaFitoModel>,
  ): void {
    this.stableValueChanges({
      value: formModel,
      changedField: lastChangedFieldName,
      changedFields: [String(lastChangedFieldName ?? '')],
      origin: 'user',
    });
  }

  public onReactiveLazyDropdownRequested(fieldName: string): void {
    const normalizedFieldName = fieldName.trim();

    if (!FitosanitariosFormComponent.TRATAMIENTO_FIELD_NAMES.some((entry) => entry === normalizedFieldName)) {
      return;
    }

    this.loadTratamientosOnDemand();
  }

  public onReactiveLazyDropdownFilterRequested(request: ReactiveLazyDropdownFilterRequest): void {
    const normalizedFieldName = request.fieldName.trim();

    if (!FitosanitariosFormComponent.TRATAMIENTO_FIELD_NAMES.some((entry) => entry === normalizedFieldName)) {
      return;
    }

    this.loadTratamientosRemoteFilter(request.filter);
  }

  public onReactiveFormLifecycleEvent(event: ReactiveFormLifecycleEvent<TareaFitoModel>): void {
    if (event.type !== 'previousDataPatched' && event.type !== 'previousDataChanged') {
      return;
    }

    const modelChanges = this.captureStableValueChange(event.value as TareaFitoModel);

    this.previousDataLoaded = {
      ...(this.previousDataLoaded ?? {}),
      ...modelChanges,
    } as TareaFitoModel;
    this.form.model = {
      ...this.form.model,
      ...modelChanges,
    } as TareaFitoModel;
    this.syncModelFromForm();
    this.applyLoadedReactiveState();
  }

  public handleFormValueChange(
    formModel: ReactiveFormValue<TareaFitoModel>,
    lastChangedFieldName: ReactiveFormChangedField<TareaFitoModel>,
  ): void {
    const changedFieldName = String(lastChangedFieldName);

    this.traceFormChange(changedFieldName, formModel);
    this.mergeMultiselectValueIfNeeded(formModel, changedFieldName);

    this.form.model = {
      ...this.form.model,
      ...formModel,
    } as TareaFitoModel;
    this.form.tag = changedFieldName as ReactiveFormChangedField<TareaFitoModel>;
    this.syncModelFromForm();

    if (changedFieldName === 'id_finca') {
      this.clearFitosanitariosCascade(['id_sector', 'ids_parcelas', 'id_tratamiento', 'ids_productos']);
    }

    if (changedFieldName === 'id_sector') {
      this.clearFitosanitariosCascade(['ids_parcelas']);
    }

    if (changedFieldName === 'id_tratamiento') {
      this.clearFitosanitariosCascade(['ids_productos']);
      this.refreshReactiveDropdownMappings();
    }

    if (changedFieldName === 'id_cliente') {
      this.resetTratamientosOnDemandCatalogue();
    }

    if (
      changedFieldName === 'id_tratamiento' ||
      changedFieldName === 'ids_parcelas' ||
      changedFieldName === 'fecha_inicio' ||
      changedFieldName === 'fecha_fin'
    ) {
      this.triggerNumeroAplicacionesCheck();
    }

    if (changedFieldName === 'aplicado') {
      this.updateHorasRequired();
    }

    if (changedFieldName === 'hora_inicio' || changedFieldName === 'hora_fin') {
      this.updateHorasTotales();
    }

    if (changedFieldName === 'ids_parcelas' && this.getType() === FormType.CREATION) {
      const selectedParcelas = this.resolveSelectedDropdownEntities<ParcelasModel>(
        this.form.lists.parcelas,
        formModel.ids_parcelas ?? this.form.model.ids_parcelas,
      );

      this.form.model.sup_cultivada = Utils.decimalFormat(
        selectedParcelas.reduce((acc, parcela) => acc + this.toFiniteNumber(parcela.superficie_cultivada), 0),
        2,
        '.',
        ',',
        3,
      );
      this.formBuilderRef.updateForm(this.form.model, false);
    }

    if (this.env.appName === 'pyf') {
      this.form.recuperarService = this.recuperarService;
    }

    if (this.env.showClimatologia) {
      this.form.weatherService = this.weatherService;
    }

    if (this.shouldSkipClientDropdownReload(changedFieldName)) {
      return;
    }

    if (changedFieldName === 'id_cliente' && this.env.appName !== 'agricar') {
      this.reloadClientDropdowns();
    }
  }

  private mergeMultiselectValueIfNeeded(
    formModel: ReactiveFormValue<TareaFitoModel>,
    changedFieldName: string,
  ): void {
    const multiselectFieldNames = ['id_sector', 'ids_parcelas', 'ids_trabajadores', 'id_maquinaria', 'ids_asignados'];

    if (!multiselectFieldNames.includes(changedFieldName)) {
      return;
    }

    const previousValue = Array.isArray(this._multiselectMergeOverride[changedFieldName])
      ? this._multiselectMergeOverride[changedFieldName]
      : Array.isArray((this.form.model as Record<string, unknown>)[changedFieldName])
        ? (this.form.model as Record<string, unknown>)[changedFieldName] as unknown[]
        : [];
    const incomingValue = Array.isArray(formModel[changedFieldName])
      ? formModel[changedFieldName] as unknown[]
      : [];
    const sanitizedPreviousValue = this.sanitizeMultiselectValues(previousValue);
    const sanitizedIncomingValue = this.sanitizeMultiselectValues(incomingValue);
    const control = this.formBuilderRef.model?.get(changedFieldName);

    if (sanitizedIncomingValue.length !== incomingValue.length) {
      formModel[changedFieldName] = sanitizedIncomingValue as never;
      control?.setValue(sanitizedIncomingValue, { emitEvent: false });
    }

    if (sanitizedPreviousValue.length === 0 || sanitizedIncomingValue.length === 0) {
      delete this._multiselectMergeOverride[changedFieldName];
      return;
    }

    const dropdownValues = this.getDropdownValuesForMultiselect(changedFieldName);
    const enrichedPreviousValue = sanitizedPreviousValue
      .map(value => this.enrichDropdownValue(value, dropdownValues))
      .filter(value => this.isMeaningfulDropdownValue(value));
    const previousIds = new Set(enrichedPreviousValue.map(value => this.getDropdownValueId(value)));
    const incomingIds = new Set(sanitizedIncomingValue.map(value => this.getDropdownValueId(value)));
    const addedValues = sanitizedIncomingValue.filter(value => !previousIds.has(this.getDropdownValueId(value)));
    const removedValues = enrichedPreviousValue.filter(value => !incomingIds.has(this.getDropdownValueId(value)));

    if (addedValues.length === 0 || removedValues.length === 0) {
      delete this._multiselectMergeOverride[changedFieldName];
      return;
    }

    const mergedValue = [...sanitizedIncomingValue, ...removedValues];

    formModel[changedFieldName] = mergedValue as never;
    this._multiselectMergeOverride[changedFieldName] = mergedValue;

    if (!control) {
      return;
    }

    control.setValue(mergedValue, { emitEvent: false });
    control.markAsDirty();

    setTimeout(() => control.setValue(mergedValue, { emitEvent: false }), 0);
  }

  private sanitizeMultiselectValues(values: unknown[]): unknown[] {
    return values.filter(value => this.isMeaningfulDropdownValue(value));
  }

  private isMeaningfulDropdownValue(value: unknown): boolean {
    if (value === null || value === undefined) {
      return false;
    }

    if (typeof value === 'string') {
      const normalizedValue = value.trim().toLowerCase();

      return normalizedValue.length > 0 && normalizedValue !== 'null' && normalizedValue !== 'undefined' && normalizedValue !== '...';
    }

    if (typeof value === 'object' && 'id' in value) {
      const id = (value as { id?: unknown }).id;

      return id !== null && id !== undefined && String(id).trim().length > 0;
    }

    return true;
  }

  private getDropdownValuesForMultiselect(changedFieldName: string): unknown[] {
    const listName = changedFieldName === 'id_sector' ? 'sectores'
      : changedFieldName === 'ids_parcelas' ? 'parcelas'
        : changedFieldName === 'ids_trabajadores' ? 'trabajadores'
          : changedFieldName === 'id_maquinaria' ? 'maquinarias'
            : changedFieldName === 'ids_asignados' ? 'usuarios'
              : '';

    if (!listName) {
      return [];
    }

    const list = (this.form.lists as any)[listName];

    return list?.filtered ?? [];
  }

  private enrichDropdownValue(value: unknown, dropdownValues: unknown[]): unknown {
    if (typeof value === 'object' && value !== null) {
      return value;
    }

    const found = dropdownValues.find(option => {
      if (typeof option !== 'object' || option === null || !('value' in option)) {
        return false;
      }

      const optionValue = (option as { value?: unknown }).value;

      if (typeof optionValue === 'object' && optionValue !== null && 'id' in optionValue) {
        return String((optionValue as { id?: unknown }).id ?? '') === String(value);
      }

      return String(optionValue ?? '') === String(value);
    });

    return typeof found === 'object' && found !== null && 'value' in found
      ? (found as { value?: unknown }).value ?? value
      : value;
  }

  private getDropdownValueId(value: unknown): string {
    if (value === null || value === undefined) {
      return '';
    }

    if (typeof value === 'object' && 'id' in value) {
      return String((value as { id?: unknown }).id ?? '');
    }

    return String(value);
  }

  private loadTratamientosOnDemand(): void {
    if (!this.form || !this.reactiveFormLoadPlan) {
      return;
    }

    const selectedClientId = this.getSelectedClientId();

    if (selectedClientId === '') {
      this.debugFito('Tratamientos lazy load cancelled: empty client id.');
      return;
    }

    if (this.isLoadingTratamientosOnDemand || this.lastLoadedTratamientosClientId === selectedClientId) {
      return;
    }

    this.isLoadingTratamientosOnDemand = true;
    this.markSupportDataPhaseLoading('lazy');
    this.debugFito('Tratamientos lazy load started.', { selectedClientId });

    ReactiveFormSupportDataExecutor.load({
      sources: FitosanitariosSupportDataSourcesFactory.createTratamientosLazySources({
        form: this.form,
        formType: this.getType(),
        env: this.env,
        selectedClientId,
        endpoints: this.createFitosanitariosSupportDataEndpoints(),
      }),
      form: this.form.formFields,
      phase: 'lazy',
      toggleLoading: false,
      onMetrics: (metric) => this.recordFitosanitariosSupportDataMetric(metric),
    }).then(() => {
      this.isLoadingTratamientosOnDemand = false;

      if (this.getSelectedClientId() !== selectedClientId) {
        this.resetTratamientosOnDemandCatalogue();
        this.markSupportDataPhaseReady('lazy');
        this.refreshReactiveTreatmentDropdownMappings();
        this.debugFito('Tratamientos lazy load ignored: client changed before completion.', { selectedClientId });

        return;
      }

      this.lastLoadedTratamientosClientId = selectedClientId;
      this.finalizeTratamientosOnDemandLoad();
      this.markSupportDataPhaseReady('lazy');
      this.refreshReactiveTreatmentDropdownMappings();
      this.debugFito('Tratamientos lazy load finished.', { selectedClientId });
    }).catch((error: unknown) => {
      this.isLoadingTratamientosOnDemand = false;
      this.markSupportDataPhaseFailed('lazy');
      this.refreshReactiveTreatmentDropdownMappings();
      this.debugFito('Tratamientos lazy load failed.', error);
      console.error('Error loading fitosanitarios tratamientos on demand.', error);
    });
  }

  private finalizeTratamientosOnDemandLoad(): void {
    this.form.lists.tratamientos.filtered = this.form.lists.tratamientos.values;
  }

  private loadTratamientosRemoteFilter(filterValue: string): void {
    if (!this.form) {
      return;
    }

    const selectedClientId = this.getSelectedClientId();
    const normalizedFilter = filterValue.trim();

    if (selectedClientId === '' || normalizedFilter === '') {
      return;
    }

    const requestKey = `${selectedClientId}|${normalizedFilter.toLocaleLowerCase()}`;

    if (requestKey === this.lastTratamientosRemoteFilterKey) {
      return;
    }

    this.lastTratamientosRemoteFilterKey = requestKey;

    this.tratamientosApi.tratamientosList.toPromise(this.createTratamientosSummaryRequestParams(selectedClientId, normalizedFilter) as never)
      .then((rows) => {
        if (this.lastTratamientosRemoteFilterKey !== requestKey || this.getSelectedClientId() !== selectedClientId) {
          return;
        }

        this.applyTratamientosRemoteRows(Array.isArray(rows) ? rows : []);
      })
      .catch((error: unknown) => {
        this.debugFito('Tratamientos remote filter failed.', error);
        console.error('Error filtering fitosanitarios tratamientos remotely.', error);
      });
  }

  private createTratamientosSummaryRequestParams(selectedClientId: string, filterValue = ''): Partial<TratamientosModel> & Record<string, string> {
    const params: Partial<TratamientosModel> & Record<string, string> = {
      id_cliente: selectedClientId,
      summary: '1',
      limit: String(FitosanitariosFormComponent.TRATAMIENTOS_REMOTE_RESULT_LIMIT),
    };

    const normalizedFilter = filterValue.trim();

    if (normalizedFilter !== '') {
      params['q'] = normalizedFilter;
    }

    return params;
  }

  private applyTratamientosRemoteRows(rows: readonly TratamientosModel[]): void {
    const mappedOptions = rows
      .map((row) => this.createTratamientoOption(row))
      .filter((option): option is FilteredValue<TratamientosModel> => option !== null);
    const selectedOptions = this.findSelectedTratamientoOptions(this.form.lists.tratamientos.values);
    const mergedOptions = this.mergeTratamientoOptions([...selectedOptions, ...mappedOptions]);

    this.form.lists.tratamientos.values = mergedOptions;
    this.form.lists.tratamientos.filtered = mergedOptions;
    this.refreshReactiveTreatmentDropdownMappings();
  }

  private createTratamientoOption(row: TratamientosModel): FilteredValue<TratamientosModel> | null {
    const id = String(row.id ?? '').trim();
    const label = String(row.nombre ?? '').trim();

    if (id === '' || label === '') {
      return null;
    }

    return {
      value: row,
      label,
      raw: row,
      valueAliases: [id],
    };
  }

  private findSelectedTratamientoOptions(options: readonly FilteredValue<TratamientosModel>[]): FilteredValue<TratamientosModel>[] {
    const fieldName = this.getTratamientoReactiveFieldName();
    const controlValue = this.formBuilderRef?.model?.get(fieldName)?.value ?? (this.form.model as Record<string, unknown>)[fieldName];
    const controlId = this.getDropdownValueId(controlValue);

    if (controlId === '') {
      return [];
    }

    return options.filter((option) => this.getDropdownValueId(option.value) === controlId);
  }

  private mergeTratamientoOptions(options: readonly FilteredValue<TratamientosModel>[]): FilteredValue<TratamientosModel>[] {
    const result = new Map<string, FilteredValue<TratamientosModel>>();

    for (const option of options) {
      const optionId = this.getDropdownValueId(option.value);

      if (optionId !== '') {
        result.set(optionId, option);
      }
    }

    return Array.from(result.values());
  }

  private resetTratamientosOnDemandCatalogue(): void {
    this.lastLoadedTratamientosClientId = '';
    this.lastTratamientosRemoteFilterKey = '';

    if (!this.form) {
      return;
    }

    this.form.lists.tratamientos.values = [];
    this.form.lists.tratamientos.filtered = [];
  }

  private reloadClientDropdowns(): void {
    const selectedClientId = this.getReactiveValueId(this.form.model.id_cliente as unknown);

    if (!selectedClientId) {
      this.debugFito('Client dropdown reload cancelled: empty client id.');
      return;
    }

    this.isReloadingClientDropdowns = true;
    this.lastReloadedClientDropdownId = selectedClientId;

    const selectedClient = this.resolveSelectedDropdownEntity<ClienteModel>(this.form.lists.clientes, selectedClientId);

    if (selectedClient) {
      StorageManager.saveClient(selectedClient);
    }

    this.dashboardEvent.emitClientChange();
    this.refreshDeclarativeLocationDropdowns();

    this.debugFito('Reloading client dropdowns.', { selectedClientId });
    this.markSupportDataPhaseLoading('deferred');
    this.resetExternalDropdowns();
    this.refreshReactiveDropdownMappings();

    ReactiveFormSupportDataExecutor.load({
      sources: FitosanitariosSupportDataSourcesFactory.createClientScopedReloadSources({
        form: this.form,
        formType: this.getType(),
        env: this.env,
        selectedClientId,
        endpoints: this.createFitosanitariosSupportDataEndpoints(),
      }),
      form: this.form.formFields,
      phase: 'all',
      toggleLoading: false,
      onMetrics: (metric) => this.recordFitosanitariosSupportDataMetric(metric),
    }).then(() => {
      this.finalizeClientScopedSupportDataReload();
      this.debugFito('Client dropdown reload finished.', { selectedClientId });
      this.markSupportDataPhaseReady('deferred');
      this.isReloadingClientDropdowns = false;
      this.refreshReactiveDropdownMappings();
    }).catch((error: unknown) => {
      this.debugFito('Client dropdown reload failed.', error);
      this.markSupportDataPhaseFailed('deferred');
      this.isReloadingClientDropdowns = false;
      this.refreshReactiveDropdownMappings();
      console.error('Error reloading fitosanitarios client dropdowns.', error);
    });
  }

  private finalizeClientScopedSupportDataReload(): void {
    this.form.lists.tratamientos.filtered = this.form.lists.tratamientos.values;

    if (this.env.filterAplicadoresByClient) {
      this.form.lists.trabajadores.filtered = this.form.lists.trabajadores.values.filter((it) => it.label !== '...');
      this.form.lists.maquinarias.filtered = this.form.lists.maquinarias.values;
    }
  }

  private syncModelFromForm(): void {
    const normalizedModel = this.toFitosanitariosModel(this.form.model);

    this.form.model = normalizedModel;
    this.updateHostModel(normalizedModel);
  }

  private toFitosanitariosModel(sourceModel: ReactiveFormValue<TareaFitoModel>): TareaFitoModel {
    const normalizedModel = new TareaFitoModel();

    Object.entries(sourceModel as Record<string, unknown>).forEach(([fieldName, value]) => {
      if (value !== undefined) {
        normalizedModel[fieldName] = value as TareaFitoModel[string];
      }
    });

    return normalizedModel;
  }

  private clearFitosanitariosCascade(fieldNames: readonly FitosanitariosCascadeField[]): void {
    const resetTargets = fieldNames.map((fieldName): ReactiveCascadeResetTarget<TareaFitoModel> => {
      delete this._multiselectMergeOverride[fieldName];

      return {
        fieldName,
        value: '',
      };
    });
    const { updates } = ReactiveCascadeController.createResetPatch<TareaFitoModel>(resetTargets);

    this.productsTratamientos = fieldNames.includes('id_tratamiento') || fieldNames.includes('ids_productos')
      ? []
      : this.productsTratamientos;
    this.form.model = {
      ...this.form.model,
      ...updates,
    } as TareaFitoModel;
    this.syncModelFromForm();
    this.formBuilderRef?.updateForm(updates, false);
  }

  private refreshReactiveDropdownMappings(): void {
    if (this.hasPendingReactiveDropdownMappingsRefresh) {
      return;
    }

    this.hasPendingReactiveDropdownMappingsRefresh = true;
    this.scheduleFitosanitariosUiTask(() => {
      this.hasPendingReactiveDropdownMappingsRefresh = false;
      ReactiveDropdownSyncController.refreshMappings({
        formBuilder: this.formBuilderRef,
        beforeRefresh: () => this.finalizeExternalDropdowns(),
      });
    });
  }

  private refreshReactiveTreatmentDropdownMappings(): void {
    this.refreshReactiveDropdownFieldMappings([this.getTratamientoReactiveFieldName()], 'optionsOnly');
  }

  private refreshReactiveDropdownFieldMappings(
    fieldNames: readonly string[],
    mode: ReactiveDropdownFieldRefreshMode = 'full',
  ): void {
    if (!this.formBuilderRef) {
      return;
    }

    ReactiveDropdownSyncController.refreshFieldMappings({
      formBuilder: this.formBuilderRef,
      fieldNames,
      mode,
    });
  }

  private getTratamientoReactiveFieldName(): string {
    return this.getType() < FormType.DELETION ? 'id_tratamiento' : 'tratamiento_nombre';
  }

  private scheduleFitosanitariosUiTask(callback: () => void): void {
    if (typeof globalThis.requestAnimationFrame === 'function') {
      globalThis.requestAnimationFrame(() => callback());

      return;
    }

    globalThis.setTimeout(() => callback(), 0);
  }

  private applyLoadedReactiveState(): void {
    this.form.model = {
      ...this.form.model,
      ...(this.initialPreviousData ?? this.previousDataLoaded ?? this.model),
    } as TareaFitoModel;
    this.syncModelFromForm();
    this.refreshDeclarativeLocationDropdowns();
    this.refreshReactiveDropdownMappings();
  }

  private markReactiveFormReady(): void {
    this.isReactiveFormReady = true;
    this.refreshFitosanitariosSupportDataReadiness();
    this.finalizeExternalDropdowns();
    this.refreshReactiveDropdownMappings();
  }

  private getReadableInitialisationError(error: unknown): string {
    if (error instanceof Error && error.message.trim() !== '') {
      return 'No se ha podido cargar el formulario fitosanitario: ' + error.message;
    }

    return 'No se ha podido cargar el formulario fitosanitario. Revisa la conexión e inténtalo de nuevo.';
  }

  private refreshDeclarativeLocationDropdowns(): void {
    if (!this.formBuilderRef) {
      return;
    }

    const previousScope = this.lastDeclarativeLocationRefreshScope;
    const nextScope = this.createDeclarativeLocationRefreshScope();
    const refreshFields = this.resolveDeclarativeLocationRefreshFields(previousScope, nextScope);

    if (refreshFields.length === 0) {
      this.debugFito('Declarative location dropdown refresh skipped: same scope.', { scope: nextScope });
      return;
    }

    this.lastDeclarativeLocationRefreshScope = nextScope;
    this.queueDeclarativeLocationDropdownRefresh(refreshFields);
  }

  private queueDeclarativeLocationDropdownRefresh(fieldNames: readonly string[]): void {
    this.pendingDeclarativeLocationRefreshFields = this.mergeUniqueStrings([
      ...this.pendingDeclarativeLocationRefreshFields,
      ...fieldNames,
    ]);

    if (this.hasPendingDeclarativeLocationRefresh) {
      return;
    }

    this.hasPendingDeclarativeLocationRefresh = true;
    this.scheduleFitosanitariosUiTask(() => {
      const refreshFields = this.pendingDeclarativeLocationRefreshFields;

      this.pendingDeclarativeLocationRefreshFields = [];
      this.hasPendingDeclarativeLocationRefresh = false;

      if (!this.formBuilderRef) {
        return;
      }

      refreshFields.forEach((fieldName) => this.formBuilderRef.refreshDeclarativeDropdown(fieldName));
    });
  }

  private resetDeclarativeLocationRefreshSignature(): void {
    this.lastDeclarativeLocationRefreshScope = null;
    this.pendingDeclarativeLocationRefreshFields = [];
    this.hasPendingDeclarativeLocationRefresh = false;
  }

  private createDeclarativeLocationRefreshScope(): FitosanitariosLocationRefreshScope {
    return {
      clientId: this.getReactiveValueId(this.form?.model?.id_cliente as unknown),
      fincaId: this.getReactiveValueId(this.form?.model?.id_finca as unknown),
      sectorIds: this.getReactiveValueIds(this.form?.model?.id_sector as unknown),
    };
  }

  private resolveDeclarativeLocationRefreshFields(
    previousScope: FitosanitariosLocationRefreshScope | null,
    nextScope: FitosanitariosLocationRefreshScope,
  ): readonly string[] {
    if (previousScope === null) {
      return ['id_finca', 'id_sector', 'ids_parcelas'];
    }

    if (previousScope.clientId !== nextScope.clientId) {
      return ['id_finca', 'id_sector', 'ids_parcelas'];
    }

    if (previousScope.fincaId !== nextScope.fincaId) {
      return ['id_sector', 'ids_parcelas'];
    }

    if (!this.areStringArraysEqual(previousScope.sectorIds, nextScope.sectorIds)) {
      return ['ids_parcelas'];
    }

    return [];
  }

  private areStringArraysEqual(first: readonly string[], second: readonly string[]): boolean {
    return first.length === second.length && first.every((value, index) => value === second[index]);
  }

  private mergeUniqueStrings(values: readonly string[]): readonly string[] {
    return Array.from(new Set(values.filter((value) => value.trim() !== '')));
  }

  /** Carga las fechas y luego crea el form-definition con ellas */
  private async setupFormConFechas(): Promise<void> {
    const rawModel = localStorage.getItem('tratamiento_temp')
      ? JSON.parse(localStorage.getItem('tratamiento_temp')!)
      : this.getModel();

    if (environment.appName === 'detorres') {
      const { dates, eventos } = await this.getEventosAPI();

      this.disabledDates = dates;

      this.form = new FitosanitariosFormDefinition(
        this.getType(),
        rawModel,
        null,
        this.disabledDates,
        eventos,
      );
    } else {
      this.form = new FitosanitariosFormDefinition(
        this.getType(),
        rawModel,
        null,
        [],
        [],
      );
    }

    this.form.model = this.initializeHostModel(this.toFitosanitariosModel({
      ...this.form.model,
      ...(rawModel as ReactiveFormValue<TareaFitoModel>),
    }));
    this.reactiveFormRecordId = this.resolveReactiveFormRecordId(this.form.model);

    const modelId = this.getModel()?.id;
    const tareaData = await this.loadInitialPreviousData(modelId);

    if (tareaData) {
      this.previousDataLoaded = this.normalizeLoadedPreviousData(tareaData);
      this.initialPreviousData = this.previousDataLoaded;
      this.seedPreviousDataDropdownOptions(this.previousDataLoaded);
      this.form.model = {
        ...this.form.model,
        ...this.previousDataLoaded,
      } as ReactiveFormValue<TareaFitoModel>;
      this.reactiveFormRecordId = this.resolveReactiveFormRecordId(this.form.model);
      this.resetDeclarativeLocationRefreshSignature();
    } else if (this.getType() === FormType.DUPLICATION) {
      this.initialPreviousData = this.toFitosanitariosModel(rawModel as ReactiveFormValue<TareaFitoModel>);
    }

    this.syncModelFromForm();
    this.configureDeclarativeLocationDataSources();
    this.configureFitosanitariosSupportDataSources();
    this.createFitosanitariosFormLoadPlan();

    await this.initCriticalFormData();
    this.formRequest.executePhase(FormPhase.LOAD);
  }


  private async loadInitialPreviousData(modelId: unknown): Promise<TareaFitoModel | null> {
    if (!modelId) {
      return null;
    }

    try {
      const response = await this.tareasApi.fitosanitariosGET.toPromise({ id: String(modelId), lite: '1' } as never);
      const values = Array.isArray(response) ? response : ((response as { data?: unknown })?.data ?? [response]);

      return (Array.isArray(values) ? values[0] : null) as TareaFitoModel | null;
    } catch (error: unknown) {
      this.debugFito('Initial fitosanitarios previous data preload failed.', error);

      return null;
    }
  }


  private normalizeLoadedPreviousData(previousData: TareaFitoModel): TareaFitoModel {
    const transformedPreviousData = this.form.formFields.previousDataTransform
      ? this.form.formFields.previousDataTransform(previousData)
      : previousData;
    const horasTotales = this.calculateHorasTotalesFromValues(
      transformedPreviousData.hora_inicio,
      transformedPreviousData.hora_fin,
    );

    if (horasTotales.length === 0) {
      return transformedPreviousData;
    }

    return {
      ...transformedPreviousData,
      horas_totales: horasTotales,
    } as TareaFitoModel;
  }

  private seedPreviousDataDropdownOptions(previousData: TareaFitoModel): void {
    this.seedPreviousTratamientoOption(previousData);
  }

  private seedPreviousTratamientoOption(previousData: TareaFitoModel): void {
    const optionId = this.resolvePreviousTratamientoId(previousData);
    const optionLabel = this.resolvePreviousTratamientoLabel(previousData, optionId);

    if (optionId === '' || optionLabel === '') {
      return;
    }

    const tratamiento: TratamientosModel = {
      ...(previousData.tratamiento ?? {}),
      id: optionId,
      nombre: optionLabel,
    };
    const clientId = this.getReactiveValueId(previousData.id_cliente as unknown) ||
      String(previousData.tratamiento?.id_cliente ?? '').trim();

    if (clientId !== '') {
      tratamiento.id_cliente = clientId;
    }

    this.prependDropdownOption(this.form.lists.tratamientos, {
      label: optionLabel,
      value: tratamiento,
      raw: tratamiento,
      valueAliases: [optionId, optionLabel],
    });
  }

  private resolvePreviousTratamientoId(previousData: TareaFitoModel): string {
    const tratamientoId = this.getReactiveValueId(previousData.id_tratamiento as unknown);

    if (tratamientoId !== '') {
      return tratamientoId;
    }

    return this.getReactiveValueId(previousData.tratamiento as unknown);
  }

  private resolvePreviousTratamientoLabel(previousData: TareaFitoModel, fallbackId: string): string {
    const tratamientoNombre = String(previousData.tratamiento_nombre ?? '').trim();

    if (tratamientoNombre !== '') {
      return tratamientoNombre;
    }

    const tratamiento = previousData.tratamiento;
    const nombre = String(tratamiento?.nombre ?? '').trim();

    return nombre !== '' ? nombre : fallbackId;
  }

  private prependDropdownOption<TValue>(
    dropdownData: DropdownData<TValue>,
    option: NonNullable<DropdownData<TValue>['values'][number]>,
  ): void {
    const optionId = this.getDropdownValueId(option.value);
    const optionLabel = String(option.label ?? '').trim();
    const isSameOption = (entry: DropdownData<TValue>['values'][number]): boolean => {
      const entryId = this.getDropdownValueId(entry.value);
      const entryLabel = String(entry.label ?? '').trim();

      return (optionId !== '' && entryId === optionId) || (optionLabel !== '' && entryLabel === optionLabel);
    };
    const values = dropdownData.values ?? [];
    const filtered = dropdownData.filtered ?? [];

    dropdownData.values = [option, ...values.filter((entry) => !isSameOption(entry))];
    dropdownData.filtered = [option, ...filtered.filter((entry) => !isSameOption(entry))];
    dropdownData.provenance = 'hydrationSeed';
  }

  private configureDeclarativeLocationDataSources(): void {
    this.form.setLocationDataSources({
      fincas: this.fincasApi.fincasGET,
      sectores: this.fincasApi.sectoresGET,
      parcelas: this.fincasApi.parcelasGET,
    });
  }

  private async updateTaskAgro(): Promise<void> {
    if (environment.appName !== 'avafitogest') return;

    const idTareaFito = this.form.model.id;
    if (!idTareaFito) return;

    const fechaFinStr = this.form.model.fecha_fin as string;
    if (!fechaFinStr) return;

    const parcelas = this.form.model.ids_parcelas as ParcelasModel[];

    try {
      const res: any = await this.tareasApi.agroambientales.GET.toPromise({
        id_tarea_fito: String(idTareaFito),
      } as never);

      const lista: any[] = Array.isArray(res) ? res : (res?.data ?? []);
      const tareaAgro = lista[0] ?? null;
      if (!tareaAgro?.id) return;

      const idsParcelas = parcelas.map(p => p.id).join(';');
      const idsSectores = Array.isArray(this.form.model.id_sector)
        ? (this.form.model.id_sector as SectorModel[]).map(s => s.id).join(';')
        : this.form.model.id_sector;

      const fechaSecaInicio = moment(Utils.toDate(fechaFinStr)).add(-1, 'days').format('DD/MM/YYYY');
      const fechaSecaFin    = moment(Utils.toDate(fechaFinStr)).add(+1, 'days').format('DD/MM/YYYY');

      const body: Record<string, any> = {
        id:                             tareaAgro.id,
        id_finca:                       (this.form.model.id_finca as any)?.id ?? this.form.model.id_finca,
        id_sector:                      idsSectores,
        id_parcelas:                    idsParcelas,
        fecha_seca_inicio_intermitente: fechaSecaInicio,
        fecha_seca_fin_intermitente:    fechaSecaFin,
      };

      const params = new HttpParams()
        .append('p1', 'generic')
        .append('p2', 'tareas_agroambientales')
        .append('p3', String(tareaAgro.id));

      await firstValueFrom(
        this.http.put<any>(`${environment.serverUrl}ws/index.php`, body, { params })
      );

    } catch (e) {
      console.error('Error en updateTaskAgro:', e);
    }
  }

  private expandFormRequest(): void {

    this.formRequest.addEvent(FormPhase.SEND, EventPhase.AFTER, (resolve) => {
      StorageManager.saveSessionDataDonJardin(
        this.form.model.id_finca ?? '',
        this.form.model.hora_inicio ?? '',
        this.form.model.hora_fin?.toString() ?? '',
      );
      resolve(true);
    });

    let isControl = false;
    let controlObtenido: TratamientosControlModel[] = [];

    this.formRequest.addEvent(FormPhase.SEND, EventPhase.AFTER, (resolve) => {
      if (this.env.appName === 'hernandorena') {
        this.tratamientosApi.tratamientosControl.GET.toPromise({
          id_tarea: this.form.model.id,
        } as never).then(control => {
          if (control?.[0]) {
            controlObtenido = control;
            isControl = true;
          } else {
            resolve(true);
          }

          return;
        }).catch(e => {
          console.log(`catch en formRequest: ${e}`);
        },
        );
      } else {
        resolve(true);
      }
    });

    if (isControl) {
      this.tratamientosApi.tratamientosControl.PUT.toPromise({
        id: controlObtenido[0]?.id,
        estado: this.form.model.aplicado ? 'Aplicado' : 'Planificado',
      } as never).then(() => {
        console.log('Control Obtenido');

        return;
      }).catch(e => {
        console.log(`catch en getPosition: ${e}`);
      },
      );
    }

  }

  private createFitosanitariosFormLoadPlan(): void {
    this.reactiveFormLoadPlan = this.createReactiveFormLoadPlan(this.form.formFields);
    this.updateReactiveFormLoadReadiness();
  }

  private updateReactiveFormLoadReadiness(): void {
    this.reactiveFormLoadReadiness = this.hostController.getLoadReadinessSnapshot({
      requireRepeatables: false,
      requireMinimumReadyTime: false,
      criticalSupportDataReady: this.criticalSupportDataReady,
      deferredCatalogsReady: true,
      deferredSupportDataReady: this.deferredSupportDataReady,
      lazyCatalogsReady: false,
    });
    this.refreshFitosanitariosSupportDataReadiness();
  }



  private markSupportDataPhaseLoading(phase: FitosanitariosSupportDataPhase): void {
    this.loadingSupportDataPhases.add(phase);
    this.failedSupportDataPhases.delete(phase);

    if (phase === 'critical') {
      this.criticalSupportDataReady = false;
    }

    if (phase === 'deferred') {
      this.deferredSupportDataReady = false;
    }

    this.updateReactiveFormLoadReadiness();
  }

  private markSupportDataPhaseReady(phase: FitosanitariosSupportDataPhase): void {
    this.loadingSupportDataPhases.delete(phase);
    this.failedSupportDataPhases.delete(phase);

    if (phase === 'critical') {
      this.criticalSupportDataReady = true;
    }

    if (phase === 'deferred') {
      this.deferredSupportDataReady = true;
    }

    this.updateReactiveFormLoadReadiness();
  }

  private markSupportDataPhaseFailed(phase: FitosanitariosSupportDataPhase): void {
    this.loadingSupportDataPhases.delete(phase);
    this.failedSupportDataPhases.add(phase);

    if (phase === 'critical') {
      this.criticalSupportDataReady = false;
    }

    if (phase === 'deferred') {
      this.deferredSupportDataReady = false;
    }

    this.updateReactiveFormLoadReadiness();
  }

  private refreshFitosanitariosSupportDataReadiness(): void {
    const sources = this.form?.formFields.supportDataSources ?? [];
    const items = sources
      .filter((source) => this.isKnownFitosanitariosSupportDataKey(source.key))
      .map((source): FitosanitariosSupportDataReadinessItem => {
        const phase = this.normalizeSupportDataPhase(source.phase);
        const status = this.resolveSupportDataVisualStatus(phase);
        const key = source.key as FitosanitariosFormSupportDataKey;

        return {
          id: key,
          label: FITOSANITARIOS_SUPPORT_DATA_LABELS[key],
          phase,
          status,
          detail: this.getSupportDataStatusDetail(status),
        };
      })
      .filter((item) => item.status !== 'ready');

    this.fitosanitariosSupportDataReadinessItems = items;
    this.fitosanitariosSupportDataReadinessSeverity = this.resolveSupportDataReadinessSeverity(items);
    this.fitosanitariosSupportDataReadinessSummary = this.resolveSupportDataReadinessSummary(items);
  }

  private normalizeSupportDataPhase(phase: string | undefined): FitosanitariosSupportDataPhase {
    if (phase === 'critical' || phase === 'lazy') {
      return phase;
    }

    return 'deferred';
  }

  private resolveSupportDataVisualStatus(phase: FitosanitariosSupportDataPhase): FitosanitariosSupportDataVisualStatus {
    if (this.failedSupportDataPhases.has(phase)) {
      return 'error';
    }

    if (this.loadingSupportDataPhases.has(phase)) {
      return 'loading';
    }

    if (phase === 'critical') {
      return this.criticalSupportDataReady ? 'ready' : 'pending';
    }

    if (phase === 'deferred') {
      return this.deferredSupportDataReady ? 'ready' : 'pending';
    }

    return 'lazy';
  }

  private getSupportDataStatusDetail(status: FitosanitariosSupportDataVisualStatus): string {
    switch (status) {
    case 'pending':
      return 'Pendiente de cargar sin bloquear la edición.';
    case 'loading':
      return 'Cargando en segundo plano.';
    case 'ready':
      return 'Disponible.';
    case 'lazy':
      return 'Se cargará cuando el campo lo necesite.';
    case 'error':
      return 'No se ha podido cargar. Revisa la conexión o recarga el formulario.';
    }
  }

  private resolveSupportDataReadinessSeverity(
    items: readonly FitosanitariosSupportDataReadinessItem[],
  ): 'info' | 'success' | 'warning' | 'danger' {
    if (items.some((item) => item.status === 'error')) {
      return 'danger';
    }

    if (items.some((item) => item.status === 'loading')) {
      return 'info';
    }

    if (items.some((item) => item.status === 'pending')) {
      return 'warning';
    }

    return 'success';
  }

  private resolveSupportDataReadinessSummary(items: readonly FitosanitariosSupportDataReadinessItem[]): string {
    if (items.some((item) => item.status === 'error')) {
      return 'Algunos catálogos no se han cargado. Puedes continuar con los campos disponibles y revisar los pendientes.';
    }

    if (items.some((item) => item.status === 'loading')) {
      return 'El formulario ya está abierto mientras se completan catálogos secundarios.';
    }

    if (items.some((item) => item.status === 'pending')) {
      return 'Quedan catálogos secundarios pendientes de cargar.';
    }

    if (items.some((item) => item.status === 'lazy')) {
      return 'Los catálogos bajo demanda se cargarán solo cuando sean necesarios.';
    }

    return '';
  }

  private isKnownFitosanitariosSupportDataKey(key: string): key is FitosanitariosFormSupportDataKey {
    return key in FITOSANITARIOS_SUPPORT_DATA_LABELS;
  }

  private initCriticalFormData(): Promise<boolean> {
    this.loadingData = true;
    this.isLoadingInitialDropdowns = true;
    this.markSupportDataPhaseLoading('critical');
    this.resetExternalDropdowns();

    this.debugFito('Critical fitosanitarios support data load started.', {
      selectedClientId: this.getSelectedClientId(),
      supportData: this.reactiveFormLoadPlan?.supportData.critical.length ?? 0,
    });

    return ReactiveFormSupportDataExecutor.load({
      form: this.form.formFields,
      loadPlan: this.reactiveFormLoadPlan,
      phase: 'critical',
      setLoading: (loading) => {
        this.loadingData = loading;
      },
      onMetrics: (metric) => this.recordFitosanitariosSupportDataMetric(metric),
    }).then(() => {
      this.loadingData = false;
      this.isLoadingInitialDropdowns = false;
      this.markSupportDataPhaseReady('critical');
      this.refreshReactiveDropdownMappings();

      this.debugFito('Critical fitosanitarios support data load finished.');

      return true;
    }).catch((error: unknown) => {
      this.loadingData = false;
      this.isLoadingInitialDropdowns = false;
      this.hostController.setLoadBlockingErrors(true);
      this.markSupportDataPhaseFailed('critical');
      this.refreshReactiveDropdownMappings();

      this.debugFito('Critical fitosanitarios support data load failed.', error);
      console.error('Error loading critical fitosanitarios form data.', error);

      throw error;
    });
  }

  private initDeferredFormData(): Promise<boolean> {
    if (!this.form || !this.reactiveFormLoadPlan) {
      return Promise.resolve(true);
    }

    this.debugFito('Deferred fitosanitarios support data load started.', {
      selectedClientId: this.getSelectedClientId(),
      supportData: this.reactiveFormLoadPlan.supportData.deferred.length,
    });
    this.markSupportDataPhaseLoading('deferred');

    return ReactiveFormSupportDataExecutor.load({
      form: this.form.formFields,
      loadPlan: this.reactiveFormLoadPlan,
      phase: 'deferred',
      setLoading: () => {
        // Deferred data must not close the already-rendered form shell.
      },
      toggleLoading: false,
      onMetrics: (metric) => this.recordFitosanitariosSupportDataMetric(metric),
    }).then(() => {
      this.markSupportDataPhaseReady('deferred');
      this.refreshReactiveDropdownMappings();

      this.debugFito('Deferred fitosanitarios support data load finished.');

      return true;
    }).catch((error: unknown) => {
      this.markSupportDataPhaseFailed('deferred');
      this.refreshReactiveDropdownMappings();
      throw error;
    });
  }

  private configureFitosanitariosSupportDataSources(): void {
    this.form.formFields.supportDataSources = FitosanitariosSupportDataSourcesFactory.create({
      form: this.form,
      formType: this.getType(),
      env: this.env,
      selectedClientId: this.getSelectedClientId(),
      endpoints: this.createFitosanitariosSupportDataEndpoints(),
    });
  }

  private createFitosanitariosSupportDataEndpoints(): FitosanitariosSupportDataEndpoints {
    return {
      clientesGET: this.clientesApi.clientesGET,
      tratamientosList: this.tratamientosApi.tratamientosList,
      justificacionesActuacionGET: this.siexApi.justificacionesActuacionGET,
      maquinariaGET: this.trabajadoresApi.maquinariaGET,
      trabajadoresGET: this.trabajadoresApi.trabajadoresGET,
      usuariosGET: this.usuariosApi.usuariosGET,
      productosGET: this.productosApi.productos.GET,
    };
  }

  private recordFitosanitariosSupportDataMetric(metric: ReactiveFormSupportDataMetricsEvent): void {
    this.registerFitosanitariosSupportDataDiagnosticsThreshold(metric);
    this.diagnostics.record({
      name: metric.sourceKey,
      group: FITOSANITARIOS_SUPPORT_DATA_DIAGNOSTIC_GROUP,
      durationMs: metric.phaseMs,
      metadata: {
        formName: metric.formName ?? 'fitosanitarios',
        sourceKey: metric.sourceKey,
        sourceLabel: this.resolveFitosanitariosSupportDataLabel(metric.sourceKey),
        phase: metric.phase,
        trigger: metric.trigger,
        cacheStatus: metric.cacheStatus,
        cacheHit: metric.cacheHit,
        staleHit: metric.staleHit,
        sourceKind: metric.sourceKind,
      },
      metrics: this.createFitosanitariosSupportDataDiagnosticMetrics(metric),
      ...(metric.error === undefined ? {} : { error: metric.error }),
    });
  }

  private registerFitosanitariosSupportDataDiagnosticsThreshold(metric: ReactiveFormSupportDataMetricsEvent): void {
    if (metric.diagnosticsThreshold === undefined) {
      return;
    }

    const threshold: DiagnosticSupportDataThresholdInput = {
      formName: metric.formName ?? 'fitosanitarios',
      sourceKey: metric.sourceKey,
      ...(metric.phase === 'all' ? {} : { phase: metric.phase }),
      ...metric.diagnosticsThreshold,
    };

    this.diagnostics.registerSupportDataThresholds([threshold]);
  }

  private createFitosanitariosSupportDataDiagnosticMetrics(metric: ReactiveFormSupportDataMetricsEvent): DiagnosticMetric[] {
    const diagnosticsMetrics: DiagnosticMetric[] = [
      { name: 'phaseMs', value: metric.phaseMs, unit: 'ms' },
      { name: 'cacheHit', value: metric.cacheHit ? 1 : 0, unit: 'count' },
      { name: 'staleHit', value: metric.staleHit ? 1 : 0, unit: 'count' },
    ];

    if (metric.networkMs !== null) {
      diagnosticsMetrics.push({ name: 'networkMs', value: metric.networkMs, unit: 'ms' });
    }

    return diagnosticsMetrics;
  }

  private resolveFitosanitariosSupportDataLabel(sourceKey: string): string {
    if (this.isKnownFitosanitariosSupportDataKey(sourceKey)) {
      return FITOSANITARIOS_SUPPORT_DATA_LABELS[sourceKey];
    }

    return sourceKey;
  }

  private getSelectedClientId(): string {
    return this.getReactiveValueId(this.form.model.id_cliente as unknown)
      || String(StorageManager.getClient()?.id ?? '');
  }

  // eslint-disable-next-line @typescript-eslint/member-ordering
  public async getEventosAPI(): Promise<{
    dates: Date[];
    eventos: { start: string; title: string; hora_inicio: string; hora_fin: string }[];
  }> {
    const fechas: Date[] = [];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let eventosRaw: any[] = [];

    try {
      eventosRaw = await this.tareasApi.eventos.GET.toPromise();
      for (const ev of eventosRaw) {
        const [dd, mm, yyyy] = ev.start.split('-').map(Number);

        if ([dd, mm, yyyy].every(Number.isInteger)) {
          fechas.push(new Date(yyyy, mm - 1, dd));
        }
      }
    } catch (err) {
      console.error('Error cargando eventos:', err);
    }

    return { dates: fechas, eventos: eventosRaw };
  }

  async getDataProducts(): Promise<void> {
    const tratamiento = this.resolveCurrentTratamiento();

    if (!tratamiento?.ids_usos) {
      this.productsTratamientos = [];
      this.form.lists.productos.values = [];
      this.form.lists.productos.filtered = [];
      return;
    }

    this.productsTratamientos = await this.loadTratamientoProductsByIdsUsos(tratamiento.ids_usos);
  }

  private normalizeIdsUsos(idsUsosRaw: unknown): string[] {
    return String(idsUsosRaw ?? '')
      .split(/[;,]/)
      .map((idUso) => idUso.trim())
      .filter((idUso) => idUso.length > 0);
  }

  private async loadTratamientoProductsByIdsUsos(idsUsosRaw: unknown): Promise<any[]> {
    const idsUsos = this.normalizeIdsUsos(idsUsosRaw);

    if (idsUsos.length === 0) {
      return [];
    }

    try {
      const result = await firstValueFrom(this.http.get<any>(
        `${environment.serverUrl}ws/index.php?p1=mg&p2=getById&id=${idsUsos.join(',')}`,
      ));

      if (Array.isArray(result)) {
        return result;
      }

      return Array.isArray(result?.data) ? result.data : [];
    } catch (error: unknown) {
      console.warn('No se han podido cargar los productos del tratamiento desde mg/getById.', error);

      return [];
    }
  }

  /**
   * Filtra vista por (año fecha aplicacion) + tratamiento + parcela de la tarea actual,
   * cuenta por num_registro_producto y compara con n_aplicaciones del mg/getById.
   */
  private checkNumeroAplicacionesConVista(vistaRows: any[]): void {
    const taskFecha = this.form?.model?.fecha_inicio ?? this.form?.model?.fecha_fin ?? null;
    const taskYear = this.getYearFromDDMMYYYY(taskFecha);

    const parcelaIds = this.getParcelaIdsFromModel(this.form?.model?.ids_parcelas);

    const isDuplicateOrCreate = this.getType() === FormType.CREATION || this.getType() === FormType.DUPLICATION;
    const tareaActualId = (!isDuplicateOrCreate && this.form?.model?.id != null)
      ? String(this.form.model.id)
      : null;

    if (!taskYear || parcelaIds.length === 0) return;

    // 1) Filtrar vista por AÑO + PARCELA, excluyendo tarea actual solo en modo edición
    const filtered = (vistaRows || []).filter(r => {
      const rIdTarea = r?.id_tarea != null ? String(r.id_tarea) : null;
      if (tareaActualId && rIdTarea === tareaActualId) return false;

      const y = this.getYearFromDDMMYYYY(r?.fecha_aplicacion);
      const idPar = String(r?.id_parcela ?? '');

      return (y === taskYear && parcelaIds.includes(idPar));
    });

    // 2) Contar en BD por (registro, parcela) => key = `${registro}__${parcela}`
    const countByRegistroParcela = new Map<string, number>();
    for (const r of filtered) {
      const reg = (r?.num_registro_producto ?? '').toString().trim();
      const idPar = String(r?.id_parcela ?? '').trim();
      if (!reg || !idPar) continue;

      const key = `${reg}__${idPar}`;
      countByRegistroParcela.set(key, (countByRegistroParcela.get(key) || 0) + 1);
    }

    const exceedLines: string[] = [];
    const okLines: string[] = [];

    // 3) Por cada producto del tratamiento actual, calculamos por cada parcela seleccionada
    for (const prod of (this.productsTratamientos || [])) {
      const registro = (prod?.referencia ?? '').toString().trim(); // ej: ES-00003
      if (!registro) continue;

      const maxApps = this.toStrictInt(prod?.n_aplicaciones); // SOLO números
      if (maxApps === null) continue;

      const nombre = prod?.nombre_comercial ?? 'Producto';

      for (const parcelaId of parcelaIds) {
        const key = `${registro}__${parcelaId}`;
        const hechasBD = countByRegistroParcela.get(key) || 0;

        const totalAntesGuardar = hechasBD + 1;

        const label = `${totalAntesGuardar}/${maxApps}`;

        const parcelaTxt = this.getParcelaDisplay(parcelaId);
        const line = `${nombre} (${registro}) · ${parcelaTxt} -> ${label}`;

        if (maxApps > 0 && totalAntesGuardar > maxApps) {
          exceedLines.push(`⚠️ ${line}`);
        } else {
          okLines.push(line);
        }
      }
    }

    // 4) Toast agrupado por severidad (max 3 mensajes: success / warn / error)
    const groups: Record<'success' | 'warn' | 'error', string[]> = {
      success: [],
      warn: [],
      error: [],
    };

    const bullet = (s: string) => `• ${String(s ?? '')}`;

    for (const line of okLines) {
      const safeLine = String(line ?? '');
      const m = safeLine.match(/->\s*(\d+)\s*\/\s*(\d+)\s*$/);

      const hechasStr = m?.[1];
      const maxStr = m?.[2];

      const hechas = typeof hechasStr === 'string' ? parseInt(hechasStr, 10) : null;
      const max = typeof maxStr === 'string' ? parseInt(maxStr, 10) : null;

      let severity: 'success' | 'warn' | 'error' = 'success';
      if (hechas !== null && max !== null) {
        if (hechas < max) severity = 'success';
        else if (hechas === max) severity = 'warn';
        else severity = 'error';
      }

      groups[severity].push(bullet(line));
    }

    for (const line of exceedLines) {
      groups.error.push(bullet(line.replace(/^⚠️\s*/, '')));
    }

    const messages: any[] = [];

    if (groups.error.length) {
      messages.push({
        severity: 'error',
        summary: `Nº aplicaciones superado (${groups.error.length})`,
        detail: groups.error.join('\n'),
        sticky: true,
      });
    }

    if (groups.warn.length) {
      messages.push({
        severity: 'warn',
        summary: `Nº aplicaciones al límite (${groups.warn.length})`,
        detail: groups.warn.join('\n'),
        life: 5000,
      });
    }

    if (groups.success.length) {
      messages.push({
        severity: 'success',
        summary: `Nº aplicaciones OK (${groups.success.length})`,
        detail: groups.success.join('\n'),
        life: 3000,
      });
    }

    this.messageService.clear();
    if (messages.length) {
      this.messageService.addAll(messages);
    }
  }

  /** Devuelve año (YYYY) desde "DD/MM/YYYY" o Date o string. */
  private getYearFromDDMMYYYY(value: any): number | null {
    if (!value) return null;

    // Date object
    if (value instanceof Date && !isNaN(value.getTime())) {
      return value.getFullYear();
    }

    const s = value.toString().trim();

    // "DD/MM/YYYY"
    const m = s.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (m) return parseInt(m[3], 10);

    // "YYYY-MM-DD ..." etc
    const iso = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (iso) return parseInt(iso[1], 10);

    // fallback moment (por si llega otro formato)
    const mm = moment(s, ['DD/MM/YYYY', 'YYYY-MM-DD', moment.ISO_8601], true);
    if (mm.isValid()) return mm.year();

    return null;
  }

  /** Convierte "solo numeros" a int. Si trae texto, devuelve null. */
  private toStrictInt(v: any): number | null {
    if (v === null || v === undefined) return null;
    const s = v.toString().trim();
    if (!/^\d+$/.test(s)) return null;
    return parseInt(s, 10);
  }

  /** Extrae ids de parcelas desde el modelo (array de objetos o ids) */
  private getParcelaIdsFromModel(ids_parcelas: any): string[] {
    if (!ids_parcelas) return [];
    if (Array.isArray(ids_parcelas)) {
      return ids_parcelas
        .map(p => (typeof p === 'object' ? p?.id : p))
        .filter(Boolean)
        .map((x: any) => String(x));
    }
    // si viene como "1;2;3"
    if (typeof ids_parcelas === 'string') {
      return ids_parcelas.split(';').map(x => x.trim()).filter(Boolean);
    }
    return [];
  }

  /** Devuelve el label EXACTO del desplegable para una parcela id (fallbacks incluidos). */
  private getParcelaDropdownLabelById(parcelaId: string): string {
    const id = String(parcelaId ?? '').trim();
    if (!id) return '';

    // 1) Label del dropdown (es el que se muestra en UI)
    const fromDropdown = (this.form?.lists?.parcelas?.values ?? [])
      .find((it: any) => String(it?.value?.id ?? it?.id ?? '') === id);

    if (fromDropdown?.label) return String(fromDropdown.label);

    // 2) Si está en el modelo seleccionado como objeto ParcelasModel
    const selected = this.form?.model?.ids_parcelas;
    if (Array.isArray(selected)) {
      const found = selected.find((p: any) => String(p?.id ?? p) === id);
      if (found && typeof found === 'object') {
        const parcelaLabel = this.parcelaLabel(found as ParcelasModel);

        if (parcelaLabel) return parcelaLabel;

        const nombre = (found?.nombre ?? '').toString().trim();
        if (nombre) return nombre;
      }
    }

    // 3) fallback
    return `Parcela ${id}`;
  }

  /** Devuelve un texto corto de parcela (mismo label del dropdown, pero sin ser kilométrico si quieres). */
  private getParcelaDisplay(parcelaId: string): string {
    // Si quieres el label completo tal cual, devuelve directamente getParcelaDropdownLabelById(parcelaId)
    return this.getParcelaDropdownLabelById(parcelaId);
  }

  private _checkAppsTimer: any = null;

  private triggerNumeroAplicacionesCheck(): void {
    if (this.loadingData) return;

    const fechaReceta = this.form?.model?.fecha_inicio ?? null;
    const tratamientoSel = this.resolveCurrentTratamiento();
    const parcelas = this.form?.model?.ids_parcelas ?? null;

    const hasFecha = !!this.getYearFromDDMMYYYY(fechaReceta);
    const hasTratamiento = !!tratamientoSel;
    const parcelaIds = this.getParcelaIdsFromModel(parcelas);
    const hasParcelas = parcelaIds.length > 0;

    if (!hasFecha || !hasTratamiento || !hasParcelas) return;

    if (this._checkAppsTimer) clearTimeout(this._checkAppsTimer);

    this._checkAppsTimer = setTimeout(async () => {
      try {
        // 1) Cargar productos del tratamiento (mg/getById) SIN usar getDataProducts
        this.productsTratamientos = await this.loadTratamientoProductsByIdsUsos(tratamientoSel?.ids_usos);

        if (this.productsTratamientos.length === 0) {
          return;
        }

        // 2) Leer vista y lanzar comprobación
        const resp: any = await this.productosApi.vistaNumeroAplicaciones.GET.toPromise({} as never);
        const vistaRows: any[] = Array.isArray(resp) ? resp : (resp?.data ?? []);

        this.checkNumeroAplicacionesConVista(vistaRows);
      } catch (e) {
        console.error('Error en triggerNumeroAplicacionesCheck:', e);
      }
    }, 200);
  }

  private parcelaLabel = (p: ParcelasModel) => {
    const nombre = (p.nombre ?? '').toString().trim();
    const variedad = (p.variedad ?? 'SIN VARIEDAD').toString().trim();

    const pol = (p.poligono ?? '').toString().trim();
    const num = (p.numero ?? '').toString().trim();
    const rec = (p.recinto ?? '').toString().trim();
    const codigos = [pol, num, rec].filter(Boolean).join('-');

    const supRaw = (p.superficie_cultivada ?? p.superficie_sigpac ?? p.superficie ?? '0').toString();
    const supNum = parseFloat(supRaw.replace(',', '.')) || 0;
    const supFmt = supNum.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    const uds = this.env.textoSuperficie || 'ha';

    let zonaRiegoAbrev = '';
    if ((p.cultivo ?? '').toLowerCase() === 'arroz') {
      const zr = (p.zona_riego ?? '').toString().toLowerCase();
      if (zr.includes('alta')) zonaRiegoAbrev = 'ZA';
      else if (zr.includes('baja')) zonaRiegoAbrev = 'ZB';
    }

    const variedadConZona = zonaRiegoAbrev
      ? `${variedad} - ${zonaRiegoAbrev}`
      : variedad;

    const derecha = [
      codigos || undefined,
      `${supFmt} ${uds}`
    ].filter(Boolean).join(' · ');

    return `${nombre} - ${variedadConZona} — ${derecha}`;
  };

  /** Coerce a value to a finite number; returns 0 if not numeric. */
  public toFiniteNumber(v: unknown): number {
    if (typeof v === 'number') { return Number.isFinite(v) ? v : 0; }
    if (typeof v === 'string') {
      const s = v.trim();

      if (s === '' || /^(?:NaN|undefined|null)$/i.test(s)) { return 0; }
      // remove thousand separators and normalize decimal comma
      const cleaned = s.replace(/\s/g, '').replace(/\.(?=\d{3}(?:\D|$))/g, '').replace(/,/, '.');
      const n = Number(cleaned);

      return Number.isFinite(n) ? n : 0;
    }
    return 0;
  }

  private randomIntBetween(min: number, max: number): number {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  private updateHorasTotales(): void {
    const horasTotales = this.calculateHorasTotalesFromValues(
      this.form.model.hora_inicio,
      this.form.model.hora_fin,
    );

    if (horasTotales.length === 0 || this.form.model.horas_totales === horasTotales) {
      return;
    }

    this.form.model.horas_totales = horasTotales;
    this.formBuilderRef.updateForm({ horas_totales: horasTotales }, false);
  }

  private calculateHorasTotalesFromValues(horaInicio: unknown, horaFin: unknown): string {
    const startMinutes = this.parseTimeToMinutes(horaInicio);
    const endMinutes = this.parseTimeToMinutes(horaFin);

    if (startMinutes === null || endMinutes === null) {
      return '';
    }

    const minutesPerDay = FitosanitariosFormComponent.HOURS_PER_DAY * FitosanitariosFormComponent.MINUTES_PER_HOUR;
    const totalMinutes = endMinutes >= startMinutes
      ? endMinutes - startMinutes
      : (endMinutes + minutesPerDay) - startMinutes;

    return this.formatMinutesAsTime(totalMinutes);
  }

  private parseTimeToMinutes(value: unknown): number | null {
    const timeValue = value instanceof Date
      ? `${value.getHours()}:${value.getMinutes()}`
      : String(value ?? '').trim();
    const match = /^(\d{1,2}):(\d{2})$/.exec(timeValue);

    if (!match) {
      return null;
    }

    const hours = Number(match[1]);
    const minutes = Number(match[2]);

    if (
      !Number.isInteger(hours) ||
      !Number.isInteger(minutes) ||
      hours < 0 ||
      hours >= FitosanitariosFormComponent.HOURS_PER_DAY ||
      minutes < 0 ||
      minutes > FitosanitariosFormComponent.MAX_TIME_MINUTE
    ) {
      return null;
    }

    return (hours * FitosanitariosFormComponent.MINUTES_PER_HOUR) + minutes;
  }

  private formatMinutesAsTime(totalMinutes: number): string {
    const minutesPerDay = FitosanitariosFormComponent.HOURS_PER_DAY * FitosanitariosFormComponent.MINUTES_PER_HOUR;
    const normalizedMinutes = ((totalMinutes % minutesPerDay) + minutesPerDay) % minutesPerDay;
    const hours = Math.floor(normalizedMinutes / FitosanitariosFormComponent.MINUTES_PER_HOUR);
    const minutes = normalizedMinutes % FitosanitariosFormComponent.MINUTES_PER_HOUR;

    return [hours, minutes]
      .map((timePart) => timePart.toString().padStart(FitosanitariosFormComponent.TIME_PART_PAD_LENGTH, '0'))
      .join(':');
  }

  private updateHorasRequired(): void {
    const v = this.form.model.aplicado;
    const aplicado = v === '1' || v === true || (v as unknown) === 1;

    for (const section of this.form.formFields.sections ?? []) {
      for (const field of section.fields ?? []) {
        if (field.name === 'hora_inicio' || field.name === 'hora_fin') {
          field.conditions.isRequired = aplicado;
        }
      }
    }

    const fg = this.formBuilderRef.model;
    if (fg) {
      for (const name of ['hora_inicio', 'hora_fin']) {
        const control = fg.get(name);
        if (!control) continue;

        if (aplicado) {
          control.addValidators(Validators.required);
        } else {
          control.removeValidators(Validators.required);
        }
        control.updateValueAndValidity({ emitEvent: false });
      }
    }

    this.formBuilderRef.updateForm(this.form.model, false);
  }

  private resolveCurrentTratamiento(): TratamientosModel | null {
    return this.resolveSelectedDropdownEntity<TratamientosModel>(
      this.form.lists.tratamientos,
      this.form.model.id_tratamiento ?? this.form.model.tratamiento_nombre ?? this.form.model.tratamiento ?? null,
    );
  }

  private resolveSelectedDropdownEntity<TEntity>(
    dropdown: DropdownData<TEntity>,
    value: unknown,
  ): TEntity | null {
    return ReactiveSelectionResolver.resolveValueById(dropdown, value);
  }

  private resolveSelectedDropdownEntities<TEntity>(
    dropdown: DropdownData<TEntity>,
    value: unknown,
  ): TEntity[] {
    return ReactiveSelectionResolver.resolveSelectedValues(dropdown, value);
  }

  private getReactiveValueId(value: unknown): string {
    if (typeof value === 'object' && value !== null && 'id' in value) {
      return String((value as { id?: unknown }).id ?? '');
    }

    return String(value ?? '');
  }

  private getReactiveValueIds(value: unknown): readonly string[] {
    if (Array.isArray(value)) {
      return value
        .map((item) => this.getReactiveValueId(item))
        .filter((id) => id !== '')
        .sort((first, second) => first.localeCompare(second));
    }

    const id = this.getReactiveValueId(value);

    return id === '' ? [] : [id];
  }

  private shouldSkipClientDropdownReload(changedFieldName: string): boolean {
    if (changedFieldName !== 'id_cliente') {
      return false;
    }

    const selectedClientId = this.getReactiveValueId(this.form.model.id_cliente as unknown);
    const hasExplicitClientFilter = Boolean(this.form.cliente?.id);
    const shouldSkip = !selectedClientId
      || !hasExplicitClientFilter
      || this.loadingData
      || this.isLoadingInitialDropdowns
      || this.isReloadingClientDropdowns
      || selectedClientId === this.lastReloadedClientDropdownId;

    if (shouldSkip) {
      this.debugFito('Client dropdown reload skipped.', {
        changedFieldName,
        selectedClientId,
        hasExplicitClientFilter,
        loadingData: this.loadingData,
        isLoadingInitialDropdowns: this.isLoadingInitialDropdowns,
        isReloadingClientDropdowns: this.isReloadingClientDropdowns,
        lastReloadedClientDropdownId: this.lastReloadedClientDropdownId,
      });
    }

    return shouldSkip;
  }

  private traceFormChange(changedFieldName: string, formModel: ReactiveFormValue<TareaFitoModel>): void {
    if (!this.debugFitosanitariosForm) {
      return;
    }

    this.formChangesDebugCount += 1;
    this.repeatedChangeDebugCount = this.lastDebugChangedFieldName === changedFieldName
      ? this.repeatedChangeDebugCount + 1
      : 1;
    this.lastDebugChangedFieldName = changedFieldName;

    if (
      this.formChangesDebugCount % FitosanitariosFormComponent.DEBUG_LOG_INTERVAL !== 0 &&
      this.repeatedChangeDebugCount < FitosanitariosFormComponent.DEBUG_REPEATED_CHANGE_THRESHOLD
    ) {
      return;
    }

    this.debugFito('handleFormValueChange trace.', {
      changedFieldName,
      formChangesDebugCount: this.formChangesDebugCount,
      repeatedChangeDebugCount: this.repeatedChangeDebugCount,
      idCliente: this.getReactiveValueId(this.form.model.id_cliente as unknown),
      loadingData: this.loadingData,
      isLoadingInitialDropdowns: this.isLoadingInitialDropdowns,
      isReloadingClientDropdowns: this.isReloadingClientDropdowns,
      changedValue: formModel[changedFieldName],
    });
  }

  private debugFito(message: string, data?: unknown): void {
    if (!this.debugFitosanitariosForm) {
      return;
    }

    console.warn('[FitosanitariosForm]', message, data ?? '');
  }
}
